import axios from 'axios';
import { notification } from 'antd';
import { api_url } from '../configs/app-global';
import { store } from '../redux/store';
import { clearUser } from '../redux/slices/auth';
import i18n from '../configs/i18next';
import { toast } from 'react-toastify';

const service = axios.create({
  baseURL: api_url,
});

// Config
const TOKEN_PAYLOAD_KEY = 'authorization';
const AUTH_TOKEN = 'token';
const AUTH_TOKEN_TYPE = 'Bearer';

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem(AUTH_TOKEN);

    if (access_token) {
      config.headers[TOKEN_PAYLOAD_KEY] = AUTH_TOKEN_TYPE + ' ' + access_token;
    }
    if (config.method === 'get') {
      config.params = { lang: i18n.language, ...config.params };
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: 'Error',
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const isLogoutRequest = error.config?.url?.includes('auth/logout');
    if (isLogoutRequest) {
      return Promise.reject(error);
    }

    let notificationParam = {
      message: error.response?.data?.message
        ? i18n.t(error.response.data.message)
        : (i18n.t('error') || 'Something went wrong'),
    };

    // Only 401 = session expired; 403 is permission (e.g. export denied)
    if (error.response?.status === 401) {
      const hadToken = Boolean(localStorage.getItem(AUTH_TOKEN));
      localStorage.removeItem(AUTH_TOKEN);
      store.dispatch(clearUser());
      if (hadToken) {
        notificationParam.message =
          i18n.t('please.login.again') || 'Please login again';
      } else {
        return Promise.reject(error);
      }
    }

    if (error.response?.status === 508) {
      notificationParam.message = error.response?.data?.message;
    }

    if (error.response?.status === 500) {
      notificationParam.message = error.response?.data?.message;
    }

    toast.error(notificationParam.message, {
      toastId: error.response?.status,
    });
    return Promise.reject(error);
  }
);

export default service;
